import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type TemplateCollectionQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.TemplateCollectionsListFilterInput>
  sorts?: Types.InputMaybe<Types.TemplateCollectionsListSortInput>
}>

export type TemplateCollectionQuery = {
  __typename?: 'Query'
  templateCollection: {
    __typename?: 'TemplateCollection'
    uid: string
    title: string
    fieldNames: Array<string>
    templates?: Array<{
      __typename?: 'Template'
      description?: string | null
      tags?: Array<string> | null
      title: string
      uid: string
      fields: Array<{ __typename?: 'TemplateField'; name: string; text: any }>
    }> | null
  }
}

export const TemplateCollectionDocument = gql`
  query TemplateCollection(
    $filters: TemplateCollectionsListFilterInput
    $sorts: TemplateCollectionsListSortInput
  ) {
    templateCollection(filters: $filters, sorts: $sorts) {
      uid
      title
      fieldNames
      templates {
        description
        fields {
          name
          text
        }
        tags
        title
        uid
      }
    }
  }
`
export function useTemplateCollectionQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    TemplateCollectionQuery,
    TemplateCollectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<TemplateCollectionQuery, TemplateCollectionQueryVariables>(
    TemplateCollectionDocument,
    options
  )
}
export function useTemplateCollectionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TemplateCollectionQuery,
    TemplateCollectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<TemplateCollectionQuery, TemplateCollectionQueryVariables>(
    TemplateCollectionDocument,
    options
  )
}
export type TemplateCollectionQueryHookResult = ReturnType<typeof useTemplateCollectionQuery>
export type TemplateCollectionLazyQueryHookResult = ReturnType<
  typeof useTemplateCollectionLazyQuery
>
export type TemplateCollectionQueryResult = ApolloReactCommon.QueryResult<
  TemplateCollectionQuery,
  TemplateCollectionQueryVariables
>
export function refetchTemplateCollectionQuery(variables?: TemplateCollectionQueryVariables) {
  return { query: TemplateCollectionDocument, variables: variables }
}
